<app-side-menu>
  <div class="b2b-contracts-form-container">
    <div class="form-header">
      <button class="btn-back" (click)="onCancel()">
        <i class="fas fa-arrow-left"></i>
      </button>
      <div class="title-info">
        <h1>
          <i class="fas fa-file-contract me-2"></i>
          {{ isEditMode ? 'Editar Contrato B2B' : 'Novo Contrato B2B' }}
        </h1>
        <p>{{ isEditMode ? 'Altere os dados do contrato e salve as mudanças' : 'Crie um novo contrato B2B preenchendo os dados abaixo' }}</p>
      </div>
    </div>

    <app-loading [show]="isLoadingEdit" message="Carregando contrato..."></app-loading>

    <form *ngIf="!isLoadingEdit" [formGroup]="contractForm" (ngSubmit)="onSubmit()">
      <div class="steps-indicator mb-4">
        <div class="step" [class.active]="currentStep === 1">
          <span class="step-number">1</span>
          <span class="step-title">Dados do Contrato</span>
        </div>
      </div>

      <div *ngIf="currentStep === 1">
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-info-circle me-2"></i>
            Informações Básicas do Contrato
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Número do Contrato <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="contractNumber"
                readonly>
              <small class="form-text text-muted">{{ isEditMode ? 'Número do contrato (somente leitura)' : 'Gerado automaticamente no formato B2B-ano-sequencial' }}</small>
            </div>

            <div class="col-md-6">
              <label class="form-label">Nome do Contrato <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="contractName"
                [class.is-invalid]="isFieldInvalid('contractName')"
                placeholder="Ex: Contrato de Locação de Motos - Empresa XYZ">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('contractName')">
                {{ getFieldError('contractName') }}
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Data de Início <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="startDate"
                [readonly]="!isEditMode"
                (input)="formatStartDate($event)"
                placeholder="DD/MM/YYYY">
              <small class="form-text text-muted">{{ isEditMode ? 'Formato DD/MM/YYYY' : 'Data fixa: hoje' }}</small>
            </div>

            <div class="col-md-6">
              <label class="form-label">Data de Término <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="endDate"
                (input)="formatDate($event)"
                [class.is-invalid]="isFieldInvalid('endDate')"
                placeholder="DD/MM/YYYY"
                maxlength="10">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('endDate')">
                {{ getFieldError('endDate') }}
              </div>
              <small class="form-text text-muted">Data deve ser posterior à data de início (formato: DD/MM/YYYY)</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações da Empresa -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-building me-2"></i>
            Informações da Empresa
          </h3>
        </div>
        <div class="card-body">
          <!-- Buscar empresa cadastrada (pessoa jurídica) -->
          <div class="row g-3 mb-3">
            <div class="col-12">
              <label class="form-label mb-1">Buscar empresa cadastrada</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="companySearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Digite nome ou CNPJ da empresa e clique em Pesquisar"
                  (keyup.enter)="searchCompanies()">
                <button type="button" class="btn btn-outline-primary" (click)="searchCompanies()"
                        [disabled]="isLoadingCompanySearch"
                        title="Pesquisar empresas (pessoa jurídica) e preencher dados">
                  <i class="fas fa-search" *ngIf="!isLoadingCompanySearch"></i>
                  <i class="fas fa-spinner fa-spin" *ngIf="isLoadingCompanySearch"></i>
                  Pesquisar
                </button>
              </div>
              <ul *ngIf="companySearchResults.length > 0" class="autocomplete-list mt-2">
                <li *ngFor="let c of companySearchResults"
                    class="autocomplete-item"
                    (click)="onSelectCompany(c)">
                  <strong>{{ c.name }}</strong>
                  <span *ngIf="c.tradeName"> — {{ c.tradeName }}</span>
                  · {{ c.documentNumber }}
                  <span *ngIf="c.email"> · {{ c.email }}</span>
                </li>
              </ul>
              <small class="form-text text-muted">Lista apenas empresas (pessoa jurídica). Ao clicar em um resultado, os dados do formulário serão preenchidos.</small>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Razão Social <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="companyName"
                [class.is-invalid]="isFieldInvalid('companyName')"
                placeholder="Ex: Empresa XYZ Logística Ltda">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('companyName')">
                {{ getFieldError('companyName') }}
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Nome Fantasia</label>
              <input
                type="text"
                class="form-control"
                formControlName="tradeName"
                placeholder="Ex: XYZ Express">
            </div>

            <div class="col-md-6">
              <label class="form-label">CNPJ <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="cnpj"
                [class.is-invalid]="isFieldInvalid('cnpj')"
                (input)="formatCnpj($event)"
                placeholder="12.345.678/0001-90"
                maxlength="18">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('cnpj')">
                {{ getFieldError('cnpj') }}
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">E-mail</label>
              <input
                type="email"
                class="form-control"
                formControlName="email"
                [class.is-invalid]="isFieldInvalid('email')"
                placeholder="contato@empresa.com.br">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                {{ getFieldError('email') }}
              </div>
            </div>

            <div class="col-md-12">
              <label class="form-label">Endereço</label>
              <input
                type="text"
                class="form-control"
                formControlName="address"
                [readonly]="isLoadingCep"
                placeholder="Rua das Empresas, 123">
            </div>

            <div class="col-md-4">
              <label class="form-label">Cidade</label>
              <input
                type="text"
                class="form-control"
                formControlName="city"
                [readonly]="isLoadingCep"
                placeholder="São Paulo">
            </div>

            <div class="col-md-4">
              <label class="form-label">Estado</label>
              <input
                type="text"
                class="form-control"
                formControlName="state"
                [readonly]="isLoadingCep"
                placeholder="SP"
                maxlength="2">
            </div>

            <div class="form-group">
              <label for="zipCode">CEP</label>
              <div class="cep-group">
                <input
                  type="text"
                  id="zipCode"
                  formControlName="zipCode"
                  maxlength="9"
                  (input)="formatZipCode($event)"
                  placeholder="00000-000"
                  autocomplete="postal-code"
                  [class.is-invalid]="isFieldInvalid('zipCode')"
                />
                <button type="button" class="cep-search-btn" (click)="lookupCep(contractForm.get('zipCode')?.value)">
                  <i class="fas fa-search"></i> Buscar CEP
                </button>
              </div>
              <div *ngIf="cepError" class="cep-error">{{ cepError }}</div>
              <div *ngIf="isLoadingCep" class="cep-loading">Consultando CEP...</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Telefone</label>
              <input
                type="text"
                class="form-control"
                formControlName="phoneNumber"
                (input)="formatPhone($event)"
                placeholder="(11) 3333-4444"
                maxlength="15">
            </div>
          </div>
        </div>
      </div>

      <!-- Informações do Representante -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-user me-2"></i>
            Informações do Representante
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Nome do Representante</label>
              <input
                type="text"
                class="form-control"
                formControlName="representativeName"
                placeholder="João da Silva">
            </div>

            <div class="col-md-6">
              <label class="form-label">CPF do Representante</label>
              <input
                type="text"
                class="form-control"
                formControlName="representativeCpf"
                (input)="formatCpf($event)"
                placeholder="123.456.789-00"
                maxlength="14">
            </div>

            <div class="col-md-12">
              <label class="form-label">Cargo do Representante</label>
              <input
                type="text"
                class="form-control"
                formControlName="representativeRole"
                placeholder="Diretor Comercial">
            </div>
          </div>
        </div>
      </div>

      <!-- Observações -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-sticky-note me-2"></i>
            Observações
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Notas</label>
              <textarea
                class="form-control"
                formControlName="notes"
                rows="4"
                placeholder="Ex: Contrato para locação de 10 motos para entregas"></textarea>
            </div>
          </div>
        </div>
      </div>

      </div>

      <!-- Botões de Ação -->
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
          <i class="fas fa-times me-2"></i>
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="contractForm.invalid || isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSubmitting" class="fas fa-save me-2"></i>
          {{ isSubmitting ? 'Salvando...' : (isEditMode ? 'Salvar Alterações' : 'Criar Contrato') }}
        </button>
      </div>
    </form>
  </div>
</app-side-menu>

